import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WindowsOpenFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.7442 5.58672C15.0481 4.59227 13.9105 4 12.6966 4H4.09985V19.9H19.9999V11.6663L15.7442 5.58672ZM12.6966 5.8C13.3232 5.8 13.9103 6.10569 14.2696 6.61896L17.3712 11.0499H14.4948L13.4889 9.37335C12.8266 8.26952 11.6337 7.59412 10.3464 7.59412H5.89985V5.8H12.6966Z"
      />
    </SvgIcon>
  );
});
